import { h, Component } from 'preact';
import { joinClasses, sortObjectByOrder } from 'utils/utils';
import { smoothScrollTo } from "utils/smoothScroll";
import HTML from 'components/core/html/html.js';
import { Link } from "components/core/link/link.js";
import * as actions from 'store/actions';
import Store from 'store/store';
import s from 'components/templates/info/info.sss';

export default class Info extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.state = {
			showAll: false
		};
	}

	handleClick(evt) {
		evt.preventDefault();
		if (this.state.showAll) {
			window.scrollTo({top: this.$top.offsetTop});
		}
		this.setState({
			showAll: !this.state.showAll
		});
	}

	trackClick(title, destination) {
		Store.emit(actions.NETFLIX_BUTTON_CLICK, 'things-to-keep-in-mind', title, destination);
	}

	render({ data, isDesktop, active, copy }, { showAll }) {
		let {
			id,
			title,
			text,
			items
		} = data;

		const sortedItems = sortObjectByOrder(items);
		const btn = showAll ? copy.$VIEW_FEWER || 'Read Less' : copy.$VIEW_MORE || 'Read More';
		const amountToShow = isDesktop ? 3 : 2;
		if (isDesktop) title = title.replace('<br>', '');

		const showBtn = sortedItems.length > amountToShow;

		return (
			<div class={joinClasses(s.wrapper, active && s.active)} id='info' data-section-observed ref={ref => this.$top = ref}>
				<HTML tag='h2' markdown class={s.title}>{title}</HTML>
				<HTML tag="p" class={s.text} content={text} markdown />
				{
					sortedItems.map((item, idx) => {
						const {
							headline,
							info,
							links
						} = item;

						if (idx >= amountToShow && !showAll) return;
						return (
							<div class={s.item}>
								<div class={s.left}>
									<HTML tag="h3" class={s.headline} content={headline} markdown />
									<HTML tag="p" class={s.info} content={info} markdown />
								</div>
								{links && <ul class={s.links}>
									{sortObjectByOrder(links).map(link => {
										return <Link
											href={link.href}
											download={link.download}
											class={s.link}
											target='_blank'
											extraOnClick={this.trackClick.bind(true, headline, link.href)}
										>
											{link.label ? link.label : 'Learn More'}
										</Link>;
									})}
								</ul>}
							</div>
						);
					})
				}
				{showBtn && <button class={joinClasses(s.more, showAll && s.less)} onClick={this.handleClick}>{btn}</button>}
			</div>
		);
	}

}
